"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = void 0;
/**
 * 节流函数
 * @param fn 要执行的函数
 * @param threshold 执行间隔，单位毫秒（ms）
 * @param scope 调用函数上下文
 * @returns {Function}
 */
function throttle(fn, threshold, scope) {
    if (scope === void 0) { scope = null; }
    var last;
    var deferTimer;
    return function throttled() {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        // @ts-ignore
        var context = scope || this;
        var now = +new Date();
        var args = arg;
        if (last && now < last + threshold) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshold);
        }
        else {
            last = now;
            fn.apply(context, args);
        }
    };
}
exports.throttle = throttle;
